import { render, staticRenderFns } from "./SidebarLogo.vue?vue&type=template&id=6fde82d3&scoped=true&"
import script from "./SidebarLogo.vue?vue&type=script&lang=js&"
export * from "./SidebarLogo.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLogo.vue?vue&type=style&index=0&id=6fde82d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fde82d3",
  null
  
)

export default component.exports